<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="红包雨"
      >
        <div class="slot">
        <img
          class="bg"
          :src="gameBgp"
          v-if="gameBgp"
        />
        <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShow">更换首页主图</div>
        </div>
        </div>
        <div class="slot">
          <img
            class="bg"
            :src="gameBgp2"            
            v-if="gameBgp2"
          />
          <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShowgameBgp2">更换背景图</div>
          </div>
          <img
            :src="gameBgp3"
            style="width: 100px; height: 100px;position: absolute; left:50%;top:50%;transform: translate(-50%,-50%); margin-top:-50px;"
            v-if="gameBgp3"
          />
          <div class="upload-img bg3" @click="toggleShowgameBgp3" style="margin-top:-50px;">
            <span class="hmicon icon-shangchuantupian1"></span>
          </div>
          <img
            :src="gameBgp4"
            style="width: 100px; height: 100px;position: absolute; left:50%;top:50%;transform: translate(-50%,-50%); margin-top:50px;"
            v-if="gameBgp4"
          />
          <div class="upload-img bg4" @click="toggleShowgameBgp4" style="margin-top:50px;">
            <span class="hmicon icon-shangchuantupian1"></span>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-wrap">
            <div class="flex-4">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="170px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                    maxlength="25"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameName"
                    placeholder="请输入活动标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动时间" prop="activityDate">
                  <el-date-picker
                    :default-time="['00:00:00', '23:59:59']"
                    v-model="ruleForm.activityDate"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    align="right"
                    start-placeholder="活动开始时间"
                    end-placeholder="活动结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="上传首页主图" prop="gameBgp">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp"
                    v-if="showgameBgp"
                    noCircle
                    noSquare
                    :width="750"
                    :height="1334"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShow"
                      v-if="!gameBgp"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传活动首页主图</span>
                    </div>
                    <div v-if="gameBgp" class="priview mr10 flex item-end">
                      <img :src="gameBgp" alt="首页主图" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShow">更换</el-button>
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">活动首页主图</span><br>
                      <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="上传背景图" prop="gameBgp2">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp2"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp2"
                    v-if="showgameBgp2"
                    noCircle
                    noSquare
                    :width="750"
                    :height="1334"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>

                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp2"
                      v-if="!gameBgp2"
                    >
                      <div class="add-wrapper flex flex-center">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传背景图</span>
                    </div>
                    <div v-if="gameBgp2" class="priviewbgp2 mr10 flex item-end">
                      <img :src="gameBgp2" alt="背景图" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp2"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">活动开始时背景图</span><br>
                      <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="上传红包图" prop="gameBgp3">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp3"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp3"
                    noCircle
                    noSquare
                    :width="200"
                    :height="200"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp3"
                      v-if="!gameBgp3"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传红包图</span>
                    </div>
                    <div v-if="gameBgp3" class="priviewbgp3 mr10 flex item-end">
                      <img :src="gameBgp3" alt="红包图" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp3"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">掉落的红包图</span><br>
                      <span class="form-tip">图片尺寸建议200x200（最多上传一张）</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="上传点击后的红包图" prop="gameBgp4">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccessBgp4"
                    @crop-upload-fail="cropUploadFail"
                    v-model="showgameBgp4"
                    noCircle
                    noSquare
                    :width="200"
                    :height="200"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <div class="flex upload-upload-btn">
                    <div
                      class="btn flex flex-column flex-center open-file"
                      @click="toggleShowgameBgp4"
                      v-if="!gameBgp4"
                    >
                      <div class="add-wrapper">
                        <span class="hmicon icon-hao pointer"></span>
                      </div>
                      <span>上传红包图</span>
                    </div>
                    <div v-if="gameBgp4" class="priviewbgp4 mr10 flex item-end">
                      <img :src="gameBgp4" alt="点击后的红包图" />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="toggleShowgameBgp4"
                          >更换</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <span class="form-tip">掉落点击后的红包图</span><br>
                      <span class="form-tip">图片尺寸建议200x200（最多上传一张）</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="活动规则说明" prop="gameRuleRemark">
                  <hm-rich-editor
                    v-model="ruleForm.gameRuleRemark"
                    :html="ruleForm.gameRuleRemark"
                  />
                </el-form-item>

                <div class="mt40" id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}活动规则
                </div>

                <el-form-item label="抽奖门槛" prop="drawLimitNum">
                  <span>击中红包数达到</span>
                  <el-input
                    type="number"
                    @mousewheel.prevent.native
                    style="width: 130px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.drawLimitNum"
                    placeholder="请输入个数"
                  ></el-input>
                  <span>个，可以参与抽奖</span>
                  <span class="danger">(请输入0-24之间的整数)</span>
                </el-form-item>

                <el-form-item label="参与限制" prop="drawType">
                  <template>
                    <div>
                      <el-radio label="total" v-model="ruleForm.drawType">
                        <span>总参与活动限制，限制活动期间，每人可参与活动</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.drawType !== 'total'"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.drawPrizeNumTotal"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次，中奖上限</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.drawType !== 'total'"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.eachWinningUpperLimitTotal"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次</span>
                      </el-radio>
                    </div>
                    <div>
                      <el-radio label="daily" v-model="ruleForm.drawType">
                        <span>每日参与活动限制，限制活动期间，每人每日可参与活动</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.drawType !== 'daily'"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.drawPrizeNumDaily"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次，中奖上限</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.drawType !== 'daily'"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.eachWinningUpperLimitDaily"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次</span>
                      </el-radio>
                    </div>
                    <div class="form-tip">
                      达到参与活动次数上限将不能参与活动，达到中奖上限将不再获得奖品
                    </div>
                  </template>
                </el-form-item>


                <el-form-item label="活动奖品设置" prop="drawTypeList">
                  <div
                    class="form-tips"
                    style="color: #e50163; font-size: 12px"
                  >
                    <!-- 活动奖品设置文字 -->
                  </div>
                  <el-table
                    :data="ruleForm.redEnvelopeRainPrizeRuleModels"
                    style="width: 100%"
                    ref="table"
                    border
                    stripe
                    size="small"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品类型"
                      prop="prizeType"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-select
                            clearable
                            size="small"
                            style="width:100%"
                            v-model="scope.row.prizeType"
                            placeholder="请选择奖品类型"
                          >
                            <el-option label="积分" value="1"></el-option>
                            <el-option label="优惠劵" value="2"></el-option>
                            <el-option label="实物" value="3"></el-option>
                          </el-select>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品内容"
                      prop="prizeType"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            type="number"
                            @mousewheel.prevent.native
                            v-if="scope.row.prizeType == '1'"
                            style="width:100%"
                            v-model.trim="scope.row.typeValue"
                            @input="filterGt0OrFixed('typeValue', scope.$index)"
                            size="small"
                            clearable
                            placeholder="奖品积分"
                          ></el-input>
                          <el-input
                            v-if="scope.row.prizeType == '3'"
                            style="width:100%"
                            v-model.trim="scope.row.typeValue"
                            size="small"
                            clearable
                            placeholder="实物名称"
                          ></el-input>
                          <el-select
                            v-if="scope.row.prizeType == '2'"
                            clearable
                            size="small"
                            style="width:100%"
                            v-model="scope.row.typeValue"
                            placeholder="请选择优惠券"
                          >
                            <el-option
                              :label="item.name"
                              :value="item.couponSendId"
                              v-for="(item, i) in couponList"
                              :key="i"
                            ></el-option>
                          </el-select>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品名称"
                      prop="prizeName"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="60"
                            style="width:100%"
                            v-model.trim="scope.row.prizeName"
                            placeholder="奖品名称"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品图片"
                      prop="prizeName"
                    >
                      <template slot-scope="scope">
                        <div class="flex flex-center">
                          <div
                            class="flex goods-upload-btn"
                            @click="addGoodsImg(scope.row, 'prizeImg')"
                            v-if="!scope.row.prizeImg"
                          >
                            <div
                              style="margin-left:0px"
                              class="btn flex flex-column flex-center open-file item-center"
                            >
                              <div class="add-prize-img-wrapper">
                                <span class="hmicon icon-hao pointer"></span>
                              </div>
                              <span>添加图片</span>
                            </div>
                          </div>
                          <div v-else class="mr10 flex item-end priviews">
                            <!-- <img class="logo" :src="scope.row.prizeImg" alt="logo" /> -->
                            <el-image
                              class="img"
                              :src="scope.row.prizeImg"
                              alt="logo"
                              :preview-src-list="[scope.row.prizeImg]"
                            />
                            <div
                              class="opreat-wrapper flex item-center flex-center"
                            >
                              <el-button
                                type="text"
                                @click="handleRemove(scope.$index)"
                                >删除</el-button
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="奖品数量"
                      prop="prizeNum"
                    >
                      <template slot-scope="scope">
                        <div class="p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="60"
                            style="width:100%"
                            v-model.trim="scope.row.prizeNum"
                            placeholder="请输入数量"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="winningRate"
                    >
                      <template slot="header">
                        <span class="mr10">中奖率</span>
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                        >
                          <div>
                            中奖率合计不能超过100%
                          </div>
                          <span slot="reference">
                            <i class="el-icon-question" style="fontSize:20px"></i>
                          </span>
                        </el-popover>
                      </template>
                      <template slot-scope="scope">
                        <div class="flex item-center p10">
                          <el-input
                            size="small"
                            clearable
                            class="ipt"
                            maxlength="18"
                            style="width:100%"
                            @input="filterGt0OrFixed22(scope.$index, 'winningRate')"
                            v-model.trim="scope.row.winningRate"
                            placeholder="中奖率"
                          ></el-input
                          >%
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="出奖门槛（总抽奖数到达多少次）"
                      prop="awardThreshold"
                    >
                      <template slot-scope="scope">
                        <div class="flex item-center">
                          <el-input
                            size="small"
                            clearable
                            class="mr10 ml10 ipt"
                            maxlength="18"
                            style="width:100px"
                            @input="
                              filterGt0OrFixed0(scope.$index, 'awardThreshold')
                            "
                            v-model.trim="scope.row.awardThreshold"
                            placeholder="请输入数字"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="orderSn"
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <div class="flex flex-center">
                          <div
                            style="margin-left:0px"
                            class="add-wrapper flex flex-center"
                            v-if="scope.$index === 0"
                          >
                            <span
                              class="hmicon icon-hao pointer"
                              @click="addChild(scope.$index)"
                            ></span>
                          </div>
                          <div
                            style="margin-left:0px"
                            class="minus-wrapper flex flex-center"
                            v-else
                          >
                            <span
                              class="hmicon icon-jianhao pointer"
                              @click="deleteChild(scope.$index)"
                            ></span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <div class="flex flex-center">
                  <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('ruleForm')"
                    >发布
                  </el-button>
                  <el-button size="small" @click="$router.back(-1)"
                    >返回
                  </el-button>
                </div>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showPrizeImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'goodsCenter' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
      </div>
    </div>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { arrayUnique2 } from "@/utils/utils";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";

import XLSX from "xlsx";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMSGoods,
    actPreview,
  },
  data() {    
    const patterndDrawTypeListFunc = function (rule, val, callback) {
      let flag = true;
      let flag2 = true;
      let winningRateTotal = 0;
      this.ruleForm.redEnvelopeRainPrizeRuleModels.map(v => {
        if (
          !v.prizeType ||
          !v.typeValue ||
          !v.prizeName ||
          !v.prizeNum  ||
          (!v.winningRate && v.winningRate != 0)
        ) {
          flag = false;
        }        
        if(v.prizeName.length>20){
          flag2 = false;
        }
        winningRateTotal += v.winningRate * 1;
      });
      if (!flag) {
        return callback(new Error("请填写所有项"));
      }else if(!flag2){
        return callback(new Error("奖品名称最大输入20个字符"));
      }else if(winningRateTotal > 100){
        return callback(new Error("中奖率合计不能超过100%!"));
      }else{
        callback();
      }
    }.bind(this);    
    const actDate = function (rule, val, callback) {
      if (!this.ruleForm.activityDate.length > 0) {
        return callback(new Error("请选择活动时间段"));
      }
      callback();
    }.bind(this);
    const patterndgameBgpFunc = function(rule, val, callback) {
      if (!this.gameBgp) {
        return callback(new Error("请选择首页主图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp2Func = function(rule, val, callback) {
      if (!this.gameBgp2) {
        return callback(new Error("请选择背景图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp3Func = function(rule, val, callback) {
      if (!this.gameBgp3) {
        return callback(new Error("请选择红包图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp4Func = function(rule, val, callback) {
      if (!this.gameBgp4) {
        return callback(new Error("请选择点击后的红包图"));
      }
      callback();
    }.bind(this);
    const patterndDrawLimitNumFunc = function(rule, val, callback) {
      if (!this.ruleForm.drawLimitNum) {
        return callback(new Error("请填写抽奖门槛个数"));
      }else{
        if(this.ruleForm.drawLimitNum<0||this.ruleForm.drawLimitNum>24){
        return callback(new Error("请填写0-24之间的整数"));  
        }
      }
      callback();
    }.bind(this);
    const patterndRawTypeFunc = function (rule, val, callback) {
      if (this.ruleForm.drawType === "total") {
        if (this.ruleForm.drawPrizeNumTotal && this.ruleForm.eachWinningUpperLimitTotal) {
          callback();
        } else {
          return callback(new Error("请填写参与限制次数"));
        }
      } else {
        if (this.ruleForm.drawPrizeNumDaily && this.ruleForm.eachWinningUpperLimitDaily) {
          callback();
        } else {
          return callback(new Error("请填写参与限制次数"));
        }
      }
      callback();
    }.bind(this);
    return {
      passwordList: [],
      suoyin: "",
      linshi: [],
      currentVirtualPage: 1,
      pageVirtualSize: 10,
      searchDialogCondition: {},
      selectGoodsWindow: false,
      showGoodsSn: true,
      selectOther: false,
      selectAll: false,
      expressList: [],
      errValidGoods: false,
      errInputResult: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        },
      },
      endTime: "2019-11-11 18:12:00",
      isRadio: false,

      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      gameBgp:
        "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img03.png",
      gameBgp2:
        "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img04.png",
      gameBgp3:
        "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img24.png",
      gameBgp4:
        "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img25.png",  
      showgameBgp: false,
      showgameBgp2: false,
      showgameBgp3: false,
      showgameBgp4: false,
      showPrizeImg: false,
      dialogVisible: false,
      currentGoods: {},
      steps: [
        {
          id: "base",
          name: "基本信息",
        },
        {
          id: "gameRule",
          name: "活动规则",
        },
      ],
      ruleForm: {
        gameBgp: "",
        gameType: "red_envelope_rain",
        couponSendId: "",
        gameStartTime: "",
        gameEndTime: "",
        activityDate: [],
        gameName: "",
        gameRuleRemark: "",       
        drawPrizeNumTotal: "",
        eachWinningUpperLimitTotal: "",
        drawPrizeNumDaily: "",
        eachWinningUpperLimitDaily: "",
        drawType: "",
        drawLimitNum:"",
        redEnvelopeRainPrizeRuleModels: [
          {
            prizeType: "1",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: "",
            prizeImg: "",
            winningRate: "",
            awardThreshold: 0
          }
        ],
        eachLaunchUpperLimit: "",
        eachHelpUpperLimit: "",
        automateBeTeam: "no",        
        customTimeNum: "",        
        showState: "no", //个人中心显示状态        
        quotaState: "no", //额度状态
        quotaNum: "", //额度
      },
      screening: "",
      bargainType: "people",
      rule: [
        {
          name: "",
          needHelpSum: "",
          eachLaunchUpperLimit: "",
          ruleNum: "",
        },
      ],
      threshold: {
        expressModeGroup: [],
      },
      rules: {        
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],        
        gameBgp: [
          {
            required: true,
            validator: patterndgameBgpFunc,
            trigger: "blur"
          }
        ],
        gameBgp2: [
          {
            required: true,
            validator: patterndgameBgp2Func,
            trigger: "blur"
          }
        ],
        gameBgp3: [
          {
            required: true,
            validator: patterndgameBgp3Func,
            trigger: "blur"
          }
        ],
        gameBgp4: [
          {
            required: true,
            validator: patterndgameBgp4Func,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur",
          },
        ],        
        activityDate: {
          required: true,
          validator: actDate,
          trigger: "blur",
        },
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],        
        drawType: [
          {
            required: true,
            validator: patterndRawTypeFunc,
            trigger: "change",
          },
        ],      
        drawLimitNum: [    
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },      
          {
            required: true,
            validator: patterndDrawLimitNumFunc,
            trigger: "blur"
          }
        ]  
      },

      options: [
        {
          value: "1",
          label: "1",
        },
      ],
      CouponRules: [], //券规则
      actDesc: {},
      sole: Boolean,
      isCollapse: true,
      total: 0,
      couponList: [],
      currentPage: 1,
      pageSize: 10,
      selectedCoupons: [],
      currentRow: {},
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "virtualGoods"]),
  watch: {
    "ruleForm.drawType": {
      handler(val) {
        if (val === "daily") {
          this.ruleForm.drawPrizeNumTotal = "";
          this.ruleForm.eachWinningUpperLimitTotal = "";
        } else {
          this.ruleForm.eachWinningUpperLimitDaily = "";
          this.ruleForm.drawPrizeNumDaily = "";
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.queryCouponList();
    this.calcHeight();
    this.$store.dispatch("queryStoreStyle");
    if (this.$route.query.gameId) {
        this.activityDetail().then(res => {
            console.log("res:",res.result);  
            let result = res.result;
            this.ruleForm.gameName = result.gameName;
            this.ruleForm.gameType = result.gameType;
            this.gameBgp = result.gameBgp;
            this.gameBgp2 = result.gameBgp2;
            this.gameBgp3 = result.gameBgp3;
            this.gameBgp4 = result.gameBgp4;
            this.ruleForm.gameRuleRemark = result.gameRuleRemark;
            this.ruleForm.activityDate = [
                result.gameStartTime,
                result.gameEndTime
            ];
            this.ruleForm.drawLimitNum = result.drawLimitNum;
            this.ruleForm.drawType = result.drawType;
            if (this.ruleForm.drawType == "daily") {
            this.ruleForm.drawPrizeNumDaily = result.drawPrizeNum;
            this.ruleForm.eachWinningUpperLimitDaily = result.eachWinningUpperLimit;
            } else {
              this.ruleForm.drawPrizeNumTotal = result.drawPrizeNum;
              this.ruleForm.eachWinningUpperLimitTotal = result.eachWinningUpperLimit;
            }
            this.ruleForm.redEnvelopeRainPrizeRuleModels = result.redEnvelopeRainPrizeRuleModels;
        })
    }
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    filterGt0OrFixed22(index, prop) {
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.rule.turntablePrizeRuleList[index][prop].indexOf(".") < 0 &&
        this.rule.turntablePrizeRuleList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.rule.turntablePrizeRuleList[index][prop] = parseFloat(
          this.rule.turntablePrizeRuleList[index][prop]
        );
      }
    },
    filterGt0OrFixed0(index, prop) {
      // this.rule.turntablePrizeRuleList[index][
      //   prop
      // ] = this.rule.turntablePrizeRuleList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d]/g, "");
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
      // console.log(this.rule.turntablePrizeRuleList[index][prop]);
      this.rule.turntablePrizeRuleList[index][prop] = new Number(
        this.rule.turntablePrizeRuleList[index][prop]
      );
    },
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },  
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    filterGt0OrFixed(prop, i) {
      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][
        prop
      ] = this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][
        prop
      ] = this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm.redEnvelopeRainPrizeRuleModels[i][
        prop
      ] = this.ruleForm.redEnvelopeRainPrizeRuleModels[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.uploadType === "prizeImg") {
        this.currentGoods.prizeImg = jsonData.result;
        console.log("this.currentGoods: ", this.currentGoods);
        return;
      }
      if (this.showgameBgp) {
        this.gameBgp = jsonData.result;
      }
    },
    cropUploadSuccessBgp2(jsonData) {
      if (this.showgameBgp2) {
        this.gameBgp2 = jsonData.result;
      }
    },
    cropUploadSuccessBgp3(jsonData) {
      if (this.showgameBgp3) {
        this.gameBgp3 = jsonData.result;
      }
    },
    cropUploadSuccessBgp4(jsonData) {
      if (this.showgameBgp4) {
        this.gameBgp4 = jsonData.result;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.showgameBgp = !this.showgameBgp;
    },
    toggleShowgameBgp2() {
      this.showgameBgp2 = !this.showgameBgp2;
    },
    toggleShowgameBgp3() {
      this.showgameBgp3 = !this.showgameBgp3;
    },
    toggleShowgameBgp4() {
      this.showgameBgp4 = !this.showgameBgp4;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1 <= 0 ? 1 : i - 1;
          }
        }
      });
    },
    addChild() {
      this.ruleForm.redEnvelopeRainPrizeRuleModels.push({
        prizeType: "1",
        typeValue: "",
        prizeName: "",
        prizeNum: "",
        prizePriority: "",
        prizeImg: "",
      });
    },
    deleteChild(index) {
      this.ruleForm.redEnvelopeRainPrizeRuleModels.splice(index, 1);
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      this.showPrizeImg = true;
      this.currentGoods = v;
    },
    submitForm(formName) {
      let params;  
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          this.ruleForm.gameBgp = this.gameBgp;
          this.ruleForm.gameBgp2 = this.gameBgp2;
          this.ruleForm.gameBgp3 = this.gameBgp3;
          this.ruleForm.gameBgp4 = this.gameBgp4;
          if (this.ruleForm.drawType == "daily") {
            this.ruleForm.drawPrizeNum = this.ruleForm.drawPrizeNumDaily;
            this.ruleForm.eachWinningUpperLimit = this.ruleForm.eachWinningUpperLimitDaily;
          } else {
            this.ruleForm.drawPrizeNum = this.ruleForm.drawPrizeNumTotal;
            this.ruleForm.eachWinningUpperLimit = this.ruleForm.eachWinningUpperLimitTotal;
          }
          console.log("this.ruleForm", this.ruleForm);
          params = {
            gameName: this.ruleForm.gameName,
            gameType: this.ruleForm.gameType,
            gameBgp: this.ruleForm.gameBgp,
            gameBgp2: this.ruleForm.gameBgp2,
            gameBgp3: this.ruleForm.gameBgp3,
            gameBgp4: this.ruleForm.gameBgp4,
            gameRuleRemark: this.ruleForm.gameRuleRemark,
            gameStartTime: this.ruleForm.gameStartTime,
            gameEndTime: this.ruleForm.gameEndTime,
            drawLimitNum: this.ruleForm.drawLimitNum,
            drawType: this.ruleForm.drawType,
            drawPrizeNum: this.ruleForm.drawPrizeNum,
            eachWinningUpperLimit: this.ruleForm.eachWinningUpperLimit,
            redEnvelopeRainPrizeRuleModels: this.ruleForm.redEnvelopeRainPrizeRuleModels,
          };
          console.log("params", params);

          this.$store.dispatch("saveGameInfo", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
      
    },
    handleRemove(index) {
      this.$set(this.ruleForm.redEnvelopeRainPrizeRuleModels[index], "prizeImg", "");
    },
    //查询优惠券
    queryCouponList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store.dispatch("findCouponSendByEvent", params).then((res) => {
        if (res.code === "0") {
          this.couponList = res.result;
        }
      });
    },    
    deleteAppend(index) {
      this.ruleForm.redEnvelopeRainPrizeRuleModels.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.add-goods-containers {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .btn {
    margin-left: 10px;

    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;

    .commodityImg {
      width: 150px;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .actcontent {
      width: 161px;
      height: 100px;
      margin-left: 20px;

      .activityTitle {
        font-size: 18px;
        font-weight: 600;
        margin-top: -1px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }

      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }

      .originalCost {
        color: #919191;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }

    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }

    .describe {
      width: 100%;
      color: #ffffff;
      font-size: 17px;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 248px;
    }
  }

  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
  }
}

.table {
  border: 1px solid #ddd;

  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }

  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }

  .table-row:nth-child(even) {
    background: #f7f7f7;
  }

  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.priview {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }

  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;

  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
}

.font-ms {
  font-size: 14px;
  color: #666666;
}

.priviewbgp2 {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp3,.priviewbgp4 {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.slot {
    position: relative;
    width: 375px; 
    height: 667px;
    .bg{
      width: 100%; 
      height: 100%;
    }
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    &:hover {
      .upload-img {
        display: block;
      }
    }
    .bg3,.bg4 {
      position: absolute;
      cursor: pointer;
      display: none;
      top: 50%;
      left: 50%;
      margin-left: -17px;
      margin-top: -17px;
      z-index: 9030;
      zoom: 1;
      width: 34px;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      .hmicon {
        color: #fff;
      }
    }
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
</style>
